<template>
  <ContentBlocks :entry="entry" :collection="collection" :grid-blocks="entry.gridBlocks" />
</template>
<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import { GridBlocksMatrixFragment } from '@/components/shop/collections/gridBlocks/GridBlock';

export const CollectionPageFragment = gql`
  fragment CollectionPageFragment on collections_Entry {
    title
    uri
    collectionHandle
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
    gridBlocks {
      ...GridBlocksMatrixFragment
    }
  }

  ${ContentBlocksMatrixFragment}
  ${GridBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'CollectionPage',
  components: { ContentBlocks },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    collection: {
      type: Object,
      default: () => null,
    },
  },
});
</script>
